module.exports = __webpack_public_path__ + "img/IMG_9715.40bccef1.jpeg";